import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';

import { FileService, FileValue } from '../../object-store';
import { VoiceService } from '../core';
import { MicrophoneRecorder } from '../core/microphone-recorder';

@Component({
    selector: 'cmps-localcall-voice-profile',
    templateUrl: './voice-profile.component.html',
})
export class VoiceProfileComponent implements OnInit, OnDestroy {
    /** @private */ _recording: boolean;
    /** @private */ _canSave: boolean;
    /** @private */ _uploading: boolean;
    /** @private */ _showProgress: boolean;
    /** @private */ _progress: number;

    private _bucketId: string;
    private _recorder: MicrophoneRecorder;
    private _chunks: BlobPart[];

    constructor(
        private readonly _authService: AuthService,
        private readonly _fileService: FileService,
        private readonly _voiceService: VoiceService,
    ) {}

    ngOnInit(): void {
        this._fileService
            .createTicket()
            .pipe(
                tap((bucketId) => {
                    this._bucketId = bucketId;
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        void this._recorder?.stop();
    }

    /** @private */
    _onRecordClick(): void {
        this._recording = true;
        this._canSave = false;
        this._showProgress = false;
        this._chunks = [];
        this._recorder = new MicrophoneRecorder();
        this._recorder.dataAvailable = (data) => {
            this._chunks.push(data);
        };
        this._recorder.stop_ = () => {
            this._canSave = true;
        };
        this._recorder.error = (error) => {
            alert(error.message);
            this._onStopClick();
        };
        void this._recorder.start();
    }

    /** @private */
    _onStopClick(): void {
        this._recording = false;
        this._canSave = false;
        void this._recorder?.stop();
    }

    /** @private */
    _onSaveClick(): void {
        if (this._bucketId == null) {
            return;
        }
        const files: FileValue[] = [
            {
                file: new Blob(this._chunks),
                name: `${this._authService.user.id}_voice_profile`,
            },
        ];
        this._uploading = true;
        this._showProgress = true;
        this._progress = 0;
        this._fileService
            .uploadWithProgress(this._bucketId, files)
            .pipe(
                tap((event) => {
                    if (typeof event === 'number') {
                        this._progress = event;
                    } else {
                        console.log(event);
                    }
                }),
                switchMap((event) => {
                    if (event != null && typeof event !== 'number') {
                        return this._voiceService.upsert({
                            voiceId: null,
                            userId: event.uploadFiles?.[0]?.userId,
                            objectStoreUploadFileId:
                                event.uploadFiles?.[0]?.uploadFileId,
                        });
                    }
                    return of(null);
                }),
                finalize(() => {
                    this._uploading = false;
                    /* do not set _showProgress to false */
                }),
            )
            .subscribe();
    }
}
